import { createStoreUnit } from 'src/redux/helpers';
import list from './infraMapSlice';
import refresh from './infraMapRefreshSlice';
import { INFRA_MAP_STORE } from '../constants';

const infraMapStore = createStoreUnit({
  name: INFRA_MAP_STORE,
  slices: { list, refresh },
});

export default infraMapStore;
